import { windowAvailable } from '~/utils/client-detection';

export default function IsProdEnvironment() {
	const currentNgcURL = windowAvailable() ? window?.location.href : undefined;

	// const prodRegEx = /((http(s|):\/\/|)(www|ww2|cms)\.)/gi; could be done with a regex too which is a bit more specific than the list below

	if (!currentNgcURL) return true;
	if (currentNgcURL.startsWith('https://www.')) return true;
	if (currentNgcURL.startsWith('https://ww2.')) return true;
	if (currentNgcURL.startsWith('HTTPS://WWW.')) return true;
	if (currentNgcURL.startsWith('http://www.')) return true;
	if (currentNgcURL.startsWith('http://ww2.')) return true;
	if (currentNgcURL.startsWith('HTTP://WWW.')) return true;
	if (currentNgcURL.startsWith('www.')) return true;
	if (currentNgcURL.startsWith('WWW.')) return true;
	if (currentNgcURL.startsWith('https://cms')) return true;

	return false;
}
